<template>
  <img class="wander-and-win" src="../../assets/wander-and-win.png">
</template>

<script>
export default{
  name: 'wander-and-win',
}
</script>

<style scoped lang="scss">
/** wander-and-win **/
@import '../../theme';

.wander-and-win {
  width: 180px;
  display: block;
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>
